export type ObjectType =
  | 'partner'
  | 'member'
  | 'ledger'
  | 'report'
  | 'contractor'
  | 'workProcess'
  | 'workResource'
  | 'arrangement'
  | 'lineRelation'
  | 'password'
  | 'role';

export type OperationType =
  | 'create'
  | 'edit'
  | 'delete'
  | 'relate'
  | 'save'
  | 'submit';

export type ModalTextSet = {
  /** 確認モーダルの本文 */
  confirm: string;
  /** 確認モーダルの実行ボタンテキスト */
  submit: string;
  /** 完了モーダルの本文 */
  done: string;
  /** エラーモーダルの本文 */
  error: string;
};

const modalTextMap: Partial<Record<ObjectType, Partial<Record<OperationType, ModalTextSet>>>> = {
  partner: {
    create: { confirm: '協力業者を登録します',       submit: '登録', done: '登録が完了しました',   error: '登録に失敗しました' },
    edit:   { confirm: '協力業者情報を更新します',   submit: '更新', done: '更新が完了しました',   error: '更新に失敗しました' },
    delete: { confirm: 'この協力業者を削除します',   submit: '確定', done: '削除が完了しました',   error: '削除に失敗しました' },
  },
  member: {
    create: { confirm: 'ユーザーを登録します',       submit: '登録', done: '登録が完了しました',   error: '登録に失敗しました' },
    edit:   { confirm: 'ユーザー情報を更新します',   submit: '更新', done: '更新が完了しました',   error: '更新に失敗しました' },
    delete: { confirm: 'このメンバーを削除します',   submit: '確定', done: '削除が完了しました',   error: '削除に失敗しました' },
  },
  ledger: {
    create: { confirm: '工事台帳を登録します',       submit: '登録', done: '登録が完了しました',   error: '登録に失敗しました' },
    edit:   { confirm: '工事台帳を更新します',       submit: '更新', done: '更新が完了しました',   error: '更新に失敗しました' },
    delete: { confirm: 'この工事台帳を削除します。関連する日報もすべて削除されます。', submit: '確定', done: '削除が完了しました', error: '削除に失敗しました' },
  },
  report: {
    save:   { confirm: '日報内容を保存します',           submit: '保存', done: '保存が完了しました',   error: '保存に失敗しました' },
    submit: { confirm: '日報内容を確定し、報告します',   submit: '報告', done: '報告が完了しました',   error: '報告に失敗しました' },
    delete: { confirm: 'この日報を削除します',           submit: '確定', done: '削除が完了しました',   error: '削除に失敗しました' },
  },
  contractor: {
    create: { confirm: '元請を登録します',           submit: '登録', done: '登録が完了しました',   error: '登録に失敗しました' },
    edit:   { confirm: '元請情報を更新します',       submit: '更新', done: '更新が完了しました',   error: '更新に失敗しました' },
    delete: { confirm: 'この元請業者を削除します',   submit: '確定', done: '削除が完了しました',   error: '削除に失敗しました' },
  },
  workProcess: {
    edit: { confirm: '変更内容を確定します', submit: '更新', done: '更新が完了しました', error: '更新に失敗しました' },
  },
  workResource: {
    edit: { confirm: '変更内容を確定します', submit: '更新', done: '更新が完了しました', error: '更新に失敗しました' },
  },
  arrangement: {
    create: { confirm: '人員手配を確定し、従業員に通知を行います', submit: '確定', done: '人員手配が完了しました', error: '人員手配に失敗しました' },
  },
  lineRelation: {
    relate: { confirm: 'メンバーにLINEアカウントを連携させます', submit: '連携', done: '連携が完了しました', error: '連携に失敗しました' },
  },
  password: {
    edit: { confirm: 'パスワードを変更します', submit: '変更', done: 'パスワードを変更しました', error: 'パスワードの変更に失敗しました' },
  },
  role: {
    create: { confirm: '役職を登録します',     submit: '登録', done: '登録が完了しました', error: '登録に失敗しました' },
    edit:   { confirm: '役職情報を更新します', submit: '更新', done: '更新が完了しました', error: '更新に失敗しました' },
    delete: { confirm: 'この役職を削除します', submit: '確定', done: '削除が完了しました', error: '削除に失敗しました' },
  },
};

const fallbackText: ModalTextSet = {
  confirm: '実行します',
  submit: '確定',
  done: '完了しました',
  error: '失敗しました',
};

export const getModalText = (objectType: ObjectType, operationType: OperationType): ModalTextSet =>
  modalTextMap[objectType]?.[operationType] ?? fallbackText;
